import { render, staticRenderFns } from "./pinDialog.vue?vue&type=template&id=3a9a58d6"
import script from "./pinDialog.vue?vue&type=script&lang=js"
export * from "./pinDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports